export const HandleImageError =
    (defaultImgSrc: string) =>
    (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
        e.currentTarget.src = defaultImgSrc;
    };
